import { createContext } from 'react';
import {
  ListingRequiredVisibleInfo,
  RequiredVisibleInfo,
} from 'models/Listing';
import utils from 'utils';

type ListingFieldsRequiredVisibleInfoContextProps = {
  fields: Partial<ListingRequiredVisibleInfo>;
  canChangeRequired: boolean;
  updateField: (
    fieldName: keyof ListingRequiredVisibleInfo,
    values: RequiredVisibleInfo,
    onSuccess: () => void,
  ) => Promise<void>;
};

export default createContext<
  Partial<ListingFieldsRequiredVisibleInfoContextProps>
>({
  fields: null,
  canChangeRequired: false,
  updateField: utils.noop,
});
